import React, { FC } from 'react';

type IProps = {
    fill: string;
    display: boolean;
    onClick?: () => void;
    width?: number;
    height?: number;
    className?: string;
    disabled?: boolean; 
};

export const ApprovedIcon: FC<IProps> = ({ fill, display, onClick, width, height, className, disabled }) => {
    return (
        <svg
            className={`${className} ${disabled ? 'disabled' : ''}`} 
            onClick={!disabled ? onClick : undefined}
            width={width || '16'}
            height={height || '16'}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <g style={{ opacity: display ? 1 : 0 }}>
                <path
                    d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};import React, { FC } from 'react';

type IProps = {
    fill: string;
    display: boolean;
    onClick?: () => void;
    width?: number;
    height?: number;
    className?: string;
    disabled?: boolean; 
};

export const ApprovedIcon: FC<IProps> = ({ fill, display, onClick, width, height, className, disabled }) => {
    return (
        <svg
            className={`${className} ${disabled ? 'disabled' : ''}`} 
            onClick={!disabled ? onClick : undefined}
            width={width || '16'}
            height={height || '16'}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <g style={{ opacity: display ? 1 : 0 }}>
                <path
                    d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};